import { HTTPStatusCode } from "@libs/api/types";
import {
  HouseholdMemberRelationshipUpdateType,
  ListHouseholdMemberRelationshipsQueryType,
} from "@/domain/householdMemberRelationship";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const HouseholdMemberRelationshipsApi = {
  listHouseholdMemberRelationshipsBetweenMembers: async (
    query: ListHouseholdMemberRelationshipsQueryType,
  ) => {
    const res =
      await tsRestClient().householdMemberRelationships.listHouseholdMemberRelationshipsBetweenMembers(
        {
          query,
        },
      );

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message:
        "Unexpected response in HouseholdMemberRelationshipsApi.listHouseholdMemberRelationshipsBetweenMembers",
      error: res.body,
      shouldThrowError: true,
    });
  },
  updateHouseholdMemberRelationship: async (
    id: string,
    relationshipData: HouseholdMemberRelationshipUpdateType,
  ) => {
    const res =
      await tsRestClient().householdMemberRelationships.updateHouseholdMemberRelationship(
        {
          params: { id },
          body: relationshipData,
        },
      );

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message:
        "Unexpected response in HouseholdMemberRelationshipsApi.updateHouseholdMemberRelationship",
      error: res.body,
      shouldThrowError: true,
    });
  },
  listHouseholdMemberRelationshipsByPrimaryMember: async () => {
    const res =
      await tsRestClient().householdMemberRelationships.listHouseholdMemberRelationshipsByPrimaryMember();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message:
        "Unexpected response in HouseholdMemberRelationshipsApi.listHouseholdMemberRelationshipsByPrimaryMember",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
